import React, { useState, useEffect, useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import cloudImg from '../../../../assets/images/Group 70.png';
import { Row, Col, CardBody, Card, CardHeader } from 'reactstrap';
import { useQuery } from 'react-query';
import { getInspection } from '../../../Inspection/services/inspectionsApi';
import { Spin } from 'antd'; 
import '../../utils/style.css';
import { useTranslation } from 'react-i18next';

const InspectionTypeRapporter = () => {

  const { isLoading, isError, error, data: inspections = [] } = useQuery("inspections", getInspection);
  const incidents = inspections.filter(inspection => inspection.typeInspection === "Incident");
  const { categories, counts } = useMemo(() => {
    const revisionNames = incidents.flatMap(incident =>
      incident?.revisions?.map(revision => revision.name)
    );

    const categoryCounts = revisionNames.reduce((acc, name) => {
      acc[name] = (acc[name] || 0) + 1;
      return acc;
    }, {});

    const uniqueCategories = Object.keys(categoryCounts);
    const counts = Object.values(categoryCounts);
    const maxDisplayCategories = 4;
    const displayedCategories = uniqueCategories.slice(0, maxDisplayCategories);
    const otherCategoriesCount = revisionNames.filter(name => !displayedCategories.includes(name)).length;

    const finalCategories = [...displayedCategories, 'Autres'];
    const finalCounts = [
      ...displayedCategories.map(name => categoryCounts[name]),
      otherCategoriesCount
    ];

    return { categories: finalCategories, counts: finalCounts };
  }, [incidents]);

  const colors = ['#B27BF8', '#EC6262', '#F1BD2F', '#393C3A', '#9DE9E9'];
  const {t}=useTranslation();
  const [state, setState] = useState({
    series: counts,  
    options: {
      chart: {
        width: 300,
        type: 'pie', 
      },
      labels: categories,
      colors: colors, 
      legend: {
        show: false,
        labels: {
          useSeriesColors: true,
        },
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,  
          },
        },
      }],
    },
  });

  useEffect(() => {
    if (categories.length > 0 && counts.length > 0) {
      setState(prevState => ({
        ...prevState,
        series: counts,
        options: {
          ...prevState.options,
          labels: categories,
        }
      }));
    }
  }, [categories, counts]);

  return (
         <Card style={{ borderRadius: '15px' }}>
      <CardHeader>
        <Row>
          <Col md={9}>
            <div className="card-header-subtitle">
              {t("dashboard.typeInspection")} ({incidents?.length || "0"})
            </div>
          </Col>
          <Col md={3}>
            <img src={cloudImg} alt="img" style={{ width: '55px' }} />
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <span className="loading-text">{t("dashboard.chargement")} <Spin /></span>
        ) : isError ? (
          <span className="loading-text" style={{ color: 'red' }}>
            {t("dashboard.error")}
          </span>
        ) : (
          <Row>
            <Col md={5}>
              <div>
                {categories.map((category, index) => {
                  const percentage = ((counts[index] * 100) / counts.reduce((a, b) => a + b, 0)).toFixed(1);
                  return (
                    <div key={index} className="category-item">
                      <div 
                        className="category-icon"
                        style={{ backgroundColor: colors[index] }}
                      ></div>
                      <span className="category-text">
                        {category} ({percentage}%)
                      </span>
                    </div>
                  );
                })}
              </div>
            </Col>

            <Col md={7} className="chart-container">
              <div id="chart">
                <ReactApexChart options={state.options} series={state.series} type="pie" width={200} />
              </div>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

export default InspectionTypeRapporter;
